import { LoadLASModel } from '@xeokit/xeokit-sdk';

export async function loadModelLAS(
  id: string,
  source: string,
  name: string,
  fileSize: number,
  options?: {
    fp64?: boolean;
    position?: (number | null | undefined)[];
    rotation?: (number | null | undefined)[];
    scale?: (number | null | undefined)[];
  },
): Promise<string | undefined> {
  const viewerStore = useViewerStore();
  const loader = viewerStore.getLoaders().lasLoaderPlugin;

  if (!viewerStore.isInitialized || !loader) return;

  loader.fp64 = options?.fp64 ?? false;

  const divideFator = name.endsWith('.laz') ? 7000000 : 10000000;
  const skipFactor = Math.max(1, Math.floor(fileSize / divideFator)); // Skip every nth point for large files

  loader.skip = skipFactor;

  const loaderOptions: LoadLASModel = {
    id,
    src: source,
    rotation: [90, 0, 0], // LAS files are usually in Z-up coordinate system
    loadMetadata: true,
    entityId: '3toKckUfH2jBmd$7uhJHa4', // Creates an Entity with this ID
    metaModelJSON: {
      // Creates a MetaModel with ID "myScanModel"
      metaObjects: [
        {
          id: '3toKckUfH2jBmd$7uhJHa6', // Creates this MetaObject with this ID
          name: 'My Project',
          type: 'Default',
          parent: null,
        },
        {
          id: '3toKckUfH2jBmd$7uhJHa4', // Creates this MetaObject with this ID
          name: name,
          type: 'Default',
          parent: '3toKckUfH2jBmd$7uhJHa6',
        },
      ],
    },
  };

  const t0 = performance.now();

  const sceneModel = loader.load(loaderOptions);

  return new Promise((resolve, reject) => {
    sceneModel.on('loaded', function () {
      console.log(
        `Model loaded in ${Math.floor(performance.now() - t0) / 1000.0} seconds, Points: ${sceneModel.numPoints}, Lines: ${sceneModel.numLines}, Triangles: ${sceneModel.numTriangles}`,
      );

      const viewer = viewerStore.getHelpers().viewer;

      if (!viewer) return reject();

      if (options) {
        updateModel(sceneModel, {
          position: options.position,
          // rotation: options.rotation,
          // scale: options.scale,
        });
      }

      // Configure points material
      viewer.scene.pointsMaterial.pointSize = 4;
      viewer.scene.pointsMaterial.roundPoints = true;
      viewer.scene.pointsMaterial.perspectivePoints = true;
      viewer.scene.pointsMaterial.minPerspectivePointSize = 2;
      viewer.scene.pointsMaterial.maxPerspectivePointSize = 4;
      viewer.scene.pointsMaterial.filterIntensity = true;
      viewer.scene.pointsMaterial.minIntensity = 0;
      viewer.scene.pointsMaterial.maxIntensity = 1;
      viewerStore.saveModelMemento(sceneModel.id);
      resolve(sceneModel.id);
    });

    sceneModel.on('error', function (error) {
      console.error(error);
      reject(error);
    });
  });
}
